import { render, staticRenderFns } from "./ProfileActions.vue?vue&type=template&id=392b53b8&"
import script from "./ProfileActions.vue?vue&type=script&lang=js&"
export * from "./ProfileActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports